import { Component, OnInit, Input, ElementRef, ViewChild, ContentChildren, QueryList } from '@angular/core';
import { ActionGroupComponent } from '../action-group/action-group.component';
import { IconButtonComponent } from '../icon-button/icon-button.component';

@Component({
    selector: 'app-button-group',
    templateUrl: '../action-group/action-group.component.html',
    styleUrls: ['./button-group.component.scss']
})
export class ButtonGroupComponent
    extends ActionGroupComponent
    implements OnInit {
    @ContentChildren(IconButtonComponent, { descendants: true }) buttons !: QueryList<IconButtonComponent>;

}
